/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetBrakeResponse } from '../models/ApiResponseGetBrakeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BrakePadService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseGetBrakeResponse OK
   * @throws ApiError
   */
  public getBrake({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetBrakeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/brake/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * @returns ApiResponseGetBrakeResponse OK
   * @throws ApiError
   */
  public getBrake1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetBrakeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/brake',
      query: {
        'vin': vin,
      },
    });
  }
}
